import { IconButton, Tooltip } from "@mui/material";
import { createDuplicateProduct } from "../../apis/Product/DuplicateProductApi";
import { useInvalidateQuery } from "../InvalidateQueryContext";
import copyIcon from "../../assets/design-revamp-product/product-icons/copy-icon.svg";
import TipBox from "../TipBox";

export const DuplicateButton = ({ id, onClick }) => {
  const { triggerInvalidate } = useInvalidateQuery();
  const handleCreateDuplicate = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (onClick) onClick(e);
    createDuplicateProduct({
      id: id,
      use_swal: true,
      triggerInvalidate: triggerInvalidate,
    });
  };

  return (
    <div
      style={{
        position: "absolute",
        bottom: "5px",
        right: "-3px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <TipBox title={"Copy Product"}>
        <IconButton
          size="small"
          sx={{ width: "25px", height: "25px", marginTop: "0" }}
          onClick={handleCreateDuplicate}
        >
          <img src={copyIcon} width={25} height={25} alt="Copy Product" />
        </IconButton>
      </TipBox>
    </div>
  );
};
